import { Box, Chip, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import card1 from "../../../icons/card1.png";
import card2 from "../../../icons/card2.png";
import card3 from "../../../icons/card3.png";
import demo from "../../../icons/auth_info.png";
import clsx from "clsx";
import { Camera } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: 336,
        backgroundColor: "#eee",
    },
    bgCard: {
        display: "flex",
        flexDirection: "column",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: 243,
        borderRadius: 8,
        padding: theme.spacing(2),
        flex: 1,
    },
    card1: {
        backgroundImage: `url(${card1})`,
    },
    card2: {
        backgroundImage: `url(${card2})`,
    },
    card3: {
        backgroundImage: `url(${card3})`,
    },
}));

const Banner: React.FC = () => {
    const classes = useStyles();
    return (
        <Box className={classes.root} component="div">
            <Box display="flex" width="100%">
                {[1, 2, 3].map((_, idx) => (
                    <Box
                        component="div"
                        mr={idx !== 2 && 2}
                        className={clsx(
                            classes.bgCard,
                            classes[
                                `card${idx + 1}` as "card1" | "card2" | "card3"
                            ]
                        )}
                    >
                        <Grid container spacing={2} style={{ flex: 1 }}>
                            <Grid item xs={7}>
                                <Typography
                                    variant="h6"
                                    style={{ color: "#fff" }}
                                    gutterBottom
                                >
                                    Phoebe
                                </Typography>
                                <Typography
                                    variant="body2"
                                    style={{ color: "#fff", marginBottom: 24 }}
                                >
                                    Phoebe is a fictional character from the
                                    American television series Friends.
                                </Typography>
                                <Typography
                                    variant="body1"
                                    style={{
                                        color: "#fff",
                                        textDecoration: "underline",
                                    }}
                                >
                                    Read More
                                </Typography>
                            </Grid>
                            <Grid item xs={5}>
                                <img
                                    src={demo}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 4,
                                    }}
                                    alt=""
                                />
                            </Grid>
                        </Grid>
                        <Box display="flex" alignItems="center">
                            <Chip
                                size="small"
                                icon={<Camera fontSize="small" />}
                                label={`${100}%`}
                                color="default"
                            />
                            <Typography
                                variant="body2"
                                style={{ color: "#fff", marginLeft: 4 }}
                            >
                                5 Parts . 1 Hour read
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default Banner;
